export default "__VITE_ASSET__DrU4aXJU__"